module.exports = __webpack_public_path__ + "static/img/avatar_10.3d3c11b.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_10.png
// module id = 1590
// module chunks = 61